import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { DespachanteService } from 'app/services/despachante.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-despachante-list',
  templateUrl: './despachante-list.component.html',
  styleUrls: ['./despachante-list.component.scss']
})
export class DespachanteListComponent implements OnInit {
  
  // Private variables
  private _unsubscribeAll: Subject<any> = new Subject();
  
  // Public variables
  public loading: boolean = false;
  public ColumnMode = ColumnMode;
  public rows: any[] = [];
  public basicSelectedOption: number = 10;
  public contentHeader: any;
  private tempData = [];
  public temp = [];
  public selectedStatus: any;

  @ViewChild(DatatableComponent) table: DatatableComponent;

  constructor(
    private despachanteService: DespachanteService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.loading = true;
    
    try {
      const result = await this.despachanteService.get();
      this.rows = Array.isArray(result) ? result : [];
      this.temp = Array.isArray(result) ? [...result] : [];
    } catch (error) {
      console.error('Erro ao carregar despachantes:', error);
      this.rows = [];
      this.temp = [];
    } finally {
      this.loading = false;
    }

    // Configuração do cabeçalho
    this.contentHeader = {
      headerTitle: "Despachantes",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          { name: "Início", isLink: false },
          { name: "Despachantes", isLink: false }
        ]
      }
    };
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // Add filter methods
  nomeFilter(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function (d) {
      if (d.nome != null) {
        return d.nome.toLowerCase().indexOf(val) !== -1 || !val;
      }
    });
    this.rows = temp;
    this.table.offset = 0;
  }

  contatoFilter(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function (d) {
      if (d.contato != null) {
        return d.contato.toLowerCase().indexOf(val) !== -1 || !val;
      }
    });
    this.rows = temp;
    this.table.offset = 0;
  }

  statusFilter() {
    if (this.selectedStatus == 0) {
      this.rows = this.temp;
      return false;
    }
    const val = this.selectedStatus;
    const temp = this.temp.filter(function (d) {
      return d.flg_status.toString() === val.toString();
    });
    this.rows = temp;
    this.table.offset = 0;
  }

  onEdit(id_despachante) {
    this.router.navigate(['despachante/editar/', id_despachante]);
  }

  async onDelete(id_despachante: number) {
    const result = await Swal.fire({
      title: 'Tem certeza?',
      text: "Esta ação não poderá ser revertida!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        this.loading = true;
        await this.despachanteService.delete(id_despachante);
        
        this.rows = this.rows.filter(row => row.id_despachante !== id_despachante);
        this.temp = this.temp.filter(row => row.id_despachante !== id_despachante);
        
        Swal.fire(
          'Deletado!',
          'O despachante foi deletado com sucesso.',
          'success'
        );
      } catch (error) {
        console.error('Erro ao deletar despachante:', error);
        Swal.fire(
          'Erro!',
          'Ocorreu um erro ao deletar o despachante.',
          'error'
        );
      } finally {
        this.loading = false;
      }
    }
  }

  public onCreate(): void {
    this.router.navigate(['despachante/cadastro']);
  }
}
